<mic-spinner-overlay
  id="work-order-line-details-spinner-overlay"
  ariaLabel="In Progress"
  color="primary"
  [loading]="isActionInProgress"
  class="no-top-space"
>
  <mic-breadcrumb class="mb-0" id="work-order-line-details-breadcrumb">
    <!-- Dynamic translated breadcrumbs -->
    @for (item of breadcrumbItems; track item; let last = $last) {
    <mic-breadcrumb-link
      [link]="!last ? item.link : null"
      [icon]="item.icon"
      [label]="translationService.translate(item.labelKey || item.label)"
      [ariaLabel]="translationService.translate(item.labelKey || item.label)"
    ></mic-breadcrumb-link>
    }
  </mic-breadcrumb>

  <div class="flex flex-row justify-between align-items-center mb-3">
    <span class="responsive-flex">
      <h3 id="work-order-line-details-title" class="mt-1">{{ translationService.translate('workOrderLineDetailsText') }}</h3>
      @if (!workOrderEditEnabled && this.workOrderEditEnabledFlag) {
      <div id="casing-update-warning" style="margin: 11px 0 0 30px">
        <mat-chip-set aria-label="Tag">
          <mat-chip disableRipple class="mic-chip" color="accent">
            <mat-icon style="font-size: 21px; align-content: center">info</mat-icon>
            {{ this.translationService.translate('casingUpdateDisabledText') }}
            @if (this.workOrderLine && this.workOrderLine.casingStatus !== 'SHOP_FLOOR') { &nbsp;{{
              this.translationService.translate('statusText')
            }}: {{ workOrderLine.casingStatus }} } @if (this.workOrderLine && this.workOrderLine.casingStatus === 'SHOP_FLOOR' &&
            this.workOrderLine.lockPost !== null) { &nbsp;{{ this.translationService.translate('casingLockedByText') }}
            {{ this.workOrderLine.lockedByUser ?? this.translationService.translate('workOrderLineDetailsUserText') }}
            {{ this.translationService.translate('onText') }} {{ workOrderLine.lockPost }}
            {{ this.translationService.translate('inShopfloorText') }}
            }
          </mat-chip>
        </mat-chip-set>
      </div>
      }</span
    >
    <div class="flex flex-row justify-end align-items-center">
      <button id="back-button" mat-flat-button style="margin-right: 14px" (click)="backNavigation()">
        <mat-icon>arrow_back</mat-icon>
        <span>{{ translationService.translate('backButtonText') }}</span>
      </button>
      <button
        id="save-button"
        type="submit"
        mat-flat-button
        color="primary"
        class="mic-btn-icon-left"
        [disabled]="!(workOrderEditEnabled && this.workOrderEditEnabledFlag)"
        (click)="saveChanges('SAVE')"
      >
        <mat-icon>save</mat-icon>
        <span>{{ translationService.translate('saveLinkText') }}</span>
      </button>
      <button id="export-button" mat-flat-button color="primary" style="margin-left: 8px" (click)="openExportModal()">
        <mat-icon>download</mat-icon>
        <span>{{ translationService.translate('exportText') }}</span>
      </button>
    </div>
  </div>
  <mat-accordion id="work-order-line-details-accordion">
    <mat-expansion-panel id="work-order-header-panel" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mic-icon class="mr-2" icon="folder_open" fontSet="outlined"></mic-icon>
          {{ translationService.translate('workOrderLineHeaderText') }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-divider />
      <form id="work-order-header-form" [formGroup]="workOrderHeaderForm">
        <mat-card id="work-order-header-card" class="custom-card-no-shadow view-component">
          <div class="filter-container">
            <mat-form-field id="work-order-number-field" subscriptSizing="dynamic" class="location-item">
              <mat-label>{{ translationService.translate('workOrderNumberText') }}</mat-label>
              <input id="work-order-number-input" matInput type="text" formControlName="workOrderNumber" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="work-order-status-field" subscriptSizing="dynamic" class="location-item">
              <mat-label>{{ translationService.translate('workOrderStatusText') }}</mat-label>
              <input id="work-order-status-input" matInput type="text" formControlName="workOrderStatus" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="casing-status-field" subscriptSizing="dynamic" class="location-item">
              <mat-label>{{ translationService.translate('casingStatusText') }}</mat-label>
              <input id="casing-status-input" matInput type="text" formControlName="casingStatus" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="plant-field" subscriptSizing="dynamic" class="location-item">
              <mat-label>{{ translationService.translate('plantText') }}</mat-label>
              <input id="plant-input" matInput type="text" formControlName="plant" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="site-field" subscriptSizing="dynamic" class="location-item">
              <mat-label>{{ translationService.translate('siteText') }}</mat-label>
              <input id="site-input" matInput type="text" formControlName="site" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="received-date-field" subscriptSizing="dynamic" class="location-item-small">
              <mat-label>{{ translationService.translate('woText') + ' ' + translationService.translate('receivedDateText') }}</mat-label>
              <input id="received-date-input" matInput type="text" formControlName="receivedDate" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="due-date-field" subscriptSizing="dynamic" class="location-item-small">
              <mat-label>{{ translationService.translate('woText') + ' ' + translationService.translate('dueDateText') }}</mat-label>
              <input id="due-date-input" matInput type="text" formControlName="dueDate" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="crn-field" subscriptSizing="dynamic" class="location-item">
              <mat-label>{{ translationService.translate('CRNText') }}</mat-label>
              <input id="crn-input" matInput type="text" formControlName="crn" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="customer-code-field" subscriptSizing="dynamic" class="location-item-small">
              <mat-label>{{ translationService.translate('customerNumberText') }}</mat-label>
              <input id="customer-code-input" matInput type="text" formControlName="customerCode" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="customer-name-field" subscriptSizing="dynamic" class="location-item">
              <mat-label>{{ translationService.translate('customerNameText') }}</mat-label>
              <input id="customer-name-input" matInput type="text" formControlName="customerName" placeholder="-" readonly />
            </mat-form-field>
            @if (showCustCodeField) {
            <mat-form-field id="fiscal-id-num-field" subscriptSizing="dynamic" class="location-item-small">
              <mat-label>{{ translationService.translate(custCodeFieldLabelKey) }}</mat-label>
              <input id="fiscal-id-num-input" matInput type="text" formControlName="fiscalIdNum" placeholder="-" readonly />
            </mat-form-field>
            }
            <!-- Due Day field - controlled by dueDayN -->
            @if (showDueDayField) {
            <mat-form-field id="due-day-field" subscriptSizing="dynamic" class="location-item-very-small">
              <mat-label>{{ translationService.translate('dueDayText') }}</mat-label>
              <input id="due-day-input" matInput type="text" formControlName="dueDay" placeholder="-" readonly />
            </mat-form-field>
            }
            <mat-form-field id="line-number-field" subscriptSizing="dynamic" class="location-item-small">
              <mat-label>{{ translationService.translate('lineNumberText') }}</mat-label>
              <input id="line-number-input" matInput type="text" formControlName="lineNumber" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="number-of-lines-field" subscriptSizing="dynamic" class="location-item-medium">
              <mat-label>{{ translationService.translate('totalNumberOfLineText') }}</mat-label>
              <input id="number-of-lines-input" matInput type="text" formControlName="numberOfLines" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="customer-note-field" subscriptSizing="dynamic" class="location-item-large">
              <mat-label>{{ translationService.translate('customerNotesText') }}</mat-label>
              <input id="customer-note-input" matInput type="text" formControlName="customerNote" placeholder="-" readonly />
            </mat-form-field>
          </div>
        </mat-card>
      </form>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- Tabbed Layout - Original tabs -->
  <mat-tab-group id="work-order-line-tab-group" mat-stretch-tabs="false" class="mt-2" (selectedTabChange)="onTabChange($event)">
    <!-- Work Order Line Tab -->
    <mat-tab [label]="translationService.translate('workOrderLineText')">
      <app-work-order-line-tab
        id="work-order-line-tab"
        #workOrderLineTab
        [workOrderLine]="workOrderLine"
        [workOrderLineExtended]="workOrderLineExtended"
        [workOrder]="workOrder"
        [customerType]="workOrder?.customerType"
        [showMfgDotField]="showMfgDotField"
        [showRtDotField]="showRtDotField"
        (dataChanged)="onTabDataChanged('workOrderLine', $event)"
        (hasChanges)="onTabHasChanges('workOrderLine', $event)"
        (camCheckRequired)="onCamCheckRequired($event)"
        (saveComplete)="onSaveComplete($event)"
      >
      </app-work-order-line-tab>
    </mat-tab>

    <!-- Location Information Tab -->
    <mat-tab [label]="translationService.translate('locationInformationText')">
      <app-location-information-tab id="location-information-tab" #locationInfoTab [workOrderLine]="workOrderLine">
      </app-location-information-tab>
    </mat-tab>

    <!-- Finished Product Information Tab -->
    <mat-tab [label]="translationService.translate('finishedProductInfoText')">
      <app-finished-product-tab
        id="finished-product-tab"
        #finishedProductTab
        [workOrderLineId]="workOrderLineId"
        [casingStatus]="workOrderLine?.casingStatus"
        (dataChanged)="onTabDataChanged('finishedProductInformation', $event)"
        (hasChanges)="onTabHasChanges('finishedProductInformation', $event)"
      >
      </app-finished-product-tab>
    </mat-tab>

    <!-- Audit Trail Tab -->
    @if (isAuditTrailEnable){
    <mat-tab [label]="translationService.translate('auditTrailText')">
      <app-audit-trail-tab
        id="audit-trail-tab"
        #auditTrailTab
        [workOrderLineId]="workOrderLineId"
        (dataChanged)="onTabDataChanged('auditTrail', $event)"
        (hasChanges)="onTabHasChanges('auditTrail', $event)"
      >
      </app-audit-trail-tab>
    </mat-tab>
    } @if (isCasingHistory){
    <mat-tab [label]="translationService.translate('casingHistoryText')">
      <app-casing-history-tab
        id="casing-history-tab"
        #casingHistoryTab
        [workOrderLineId]="workOrderLineId"
        [casingId]="workOrderLine?.casingId"
        (dataChanged)="onTabDataChanged('casingHistory', $event)"
        (hasChanges)="onTabHasChanges('casingHistory', $event)"
      >
      </app-casing-history-tab>
    </mat-tab>
    }
  </mat-tab-group>
</mic-spinner-overlay>
<mic-modal id="cam-alert-modal" #camAlertModal></mic-modal>
<ng-template #contentModal>
  @if(this.ntrValidationFailed){
  <div class="mb-4">
    <span class="text-base font-semibold"
      >{{ camViolationError.fieldName }} {{ this.translationService.translate('ntrCamViolationErrorTitleText') }}</span
    >
    <div class="text-sm mt-2">
      <strong>{{ camViolationError.fieldName }}</strong> : {{ camViolationError.value }},
      <strong> {{ this.translationService.translate('maximumLimitText') }}</strong> : {{ camViolationError.maximumLimit }}
    </div>
  </div>
  } @if(this.ageValidationFailed){
  <div class="mb-4">
    <span class="text-base font-semibold">{{ this.translationService.translate('ageCamViolationErrorTitleText') }}</span>
    <div class="text-sm mt-2">
      <strong>{{ camViolationError.fieldName | titlecase }}</strong> : {{ camViolationError.value }} months,
      <strong> {{ this.translationService.translate('maximumLimitText') }}</strong> : {{ camViolationError.maximumLimit }} months
    </div>
  </div>
  } @if(this.isDowngradeOption) {
  <mat-divider class="mb-3"></mat-divider>
  <div class="mt-3 mb-4">
    <span class="downgrade-title">{{ translationService.translate('selectDownGradeOptionsText') }}</span>
  </div>
  <div class="flex flex-row gap-4" [formGroup]="downgradeForm">
    <mat-form-field class="flex-1" subscriptSizing="dynamic">
      <mat-label>{{ translationService.translate('treadText') }}</mat-label>
      <mat-select
        formControlName="tread"
        (selectionChange)="onTreadSelected($event.value)"
        placeholder="{{ translationService.translate('selectTreadText') }}"
      >
        @for (tread of downgradeEligibleTreads; track tread) {
        <mat-option [value]="tread">{{ tread }}</mat-option>
        }
      </mat-select>
      @if (downgradeForm.get('tread').hasError('required') && downgradeForm.get('tread').touched) {
      <mat-error>
        {{ translationService.translate('mandatoryFieldText') }}
      </mat-error>
      }
    </mat-form-field>
    <mat-form-field class="flex-1 downgrade-input downgrade-input" subscriptSizing="dynamic" style="align-self: flex-start">
      <mat-label>{{ translationService.translate('applicationText') }}</mat-label>
      <input matInput formControlName="application" readonly />
    </mat-form-field>
    <mat-form-field class="flex-1 downgrade-input downgrade-input" subscriptSizing="dynamic" style="align-self: flex-start">
      <mat-label>{{ translationService.translate('axleText') }}</mat-label>
      <input matInput formControlName="axle" readonly />
    </mat-form-field>
  </div>
  } @else {
  <mat-divider class="mt-3 mb-3"></mat-divider>
  }
  <div class="mt-4 flex flex-row justify-end gap-3">
    <button id="cam-alert-ignore-button" mat-flat-button color="warn" (click)="closeModal('SAVE')" class="mic-btn-outline">
      {{ translationService.translate('actionIgnoreText') }}
    </button>
    @if(this.isDowngradeOption) {
    <button
      id="cam-alert-downgrade-button"
      mat-flat-button
      color="primary"
      (click)="processDowngrade()"
      class="mic-btn-outline"
      [disabled]="downgradeEligibleTreads.length === 0"
    >
      {{ translationService.translate('downgradeCasingText') }}
    </button>
    } @else {
    <button id="cam-alert-reject-button" mat-flat-button color="primary" (click)="processReject()" class="mic-btn-outline">
      {{ translationService.translate('actionRejectCasingText') }}
    </button>
    }
  </div>
</ng-template>

<!-- UNSAVED CHANGES MODAL -->
<ng-template #unsavedConfirmation>{{ this.translationService.translate('unSaveChangesText') }}</ng-template>
<mic-modal id="unsaved-changes-modal" class="modalC" #unsavedChangesModal></mic-modal>
